import {Component, OnInit, ViewChild} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";
import {Member} from "../../../service/member/member";
import {SelectorDisplay} from "../../../shared/selector/selector";
import {Message} from "../../../service/message/message";
import {CommonService} from "../../../service/common/common.service";
import {MessageService} from "../../../service/message/message.service";
import {AuthService} from "../../../service/auth/auth.service";
import {MemberService} from "../../../service/member/member.service";
import {GtmService} from "../../../service/gtm/gtm.service";

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  providers: [MemberService, MessageService]
})
export class MessageModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalDirective;
  isModalShown: boolean = false;

  messageEventSubscription;

  constructor(private authService: AuthService,
              private messageService: MessageService,
              private memberService: MemberService,
              private commonService: CommonService,
              private gtmService: GtmService) {

    this.messageEventSubscription = this.commonService.messageEvent.subscribe(
      member => this.showModal(member)
    );

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.messageEventSubscription.unsubscribe();
  }

  receiver: Member;

  selectReceiver(receiver: Member) {
    this.receiver = receiver;
  }

  memberDisplay: SelectorDisplay = (item) => {
    return (item.name) ? `${item.name} (${item.email})` : item.email;
  };

  onSendMessage(message: Message) {

    if (!this.receiver) {
      window.alert('수신자를 입력해 주세요.');
      return;
    } else if (this.receiver.email == this.authService.getEmail()) {
      window.alert('자신에게 메시지를 보낼 수 없습니다.');
      return;
    } else if (message.content.trim().length == 0) {
      window.alert('내용을 작성해 주세요.');
      return;
    }

    message.receiver = this.receiver;

    this.messageService.sendMessage(message).subscribe(
      message => {
        this.gtmService.sendMessageEvent();
        window.alert('메시지를 전송하였습니다.');
        this.receiver = null;
        this.modal.hide();
      }
    );

  }

  showModal(member: Member) {
    this.receiver = member;
    this.isModalShown = true;
    this.modal.show();
  }

  onHide(): void {
    this.isModalShown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/shared/message-modal/message-modal.component.ts